<template>
  <renewal-monitoring :on-renewal="handleRenewal" :total="calculatedTotal" :renewal-data="renewalData"
    :product-data="productData" />
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import RenewalMonitoring from './RenewalMonitoring.vue';
import { prolongationMonitoring } from '../../../services/api/request';

export default {
  name: 'renewal-monitoring-container',
  components: {
    RenewalMonitoring,
  },

  methods: {
    ...mapActions('request', ['fetchRequestFields']),
    ...mapMutations('request', ['selectedProducts']),

    handleRenewal(renewalData) {
      return prolongationMonitoring(renewalData);
    },

    findMonitoringProductId() {
      const products = Object.values(this.productsObj);
      const monitoringProduct = products.find(product =>
        product.name && (
          product.name.toLowerCase().includes('мониторинг') ||
          product.name.toLowerCase().includes('monitoring')
        )
      );
      return monitoringProduct ? monitoringProduct.id : null;
    },

    getMonitoringProductId() {
      return this.$route.query.productId || this.findMonitoringProductId();
    },
  },

  computed: {
    ...mapGetters('request', ['total', 'productsObj']),

    calculatedTotal() {
      return this.total;
    },

    productData() {
      const monitoringProductId = this.getMonitoringProductId();
      const product = this.productsObj[monitoringProductId];

      return product || { cost: 0 };
    },

    renewalData() {
      return {
        lastName: this.$route.query.lastName,
        firstName: this.$route.query.firstName,
        middleName: this.$route.query.middleName,
        dateBirth: this.$route.query.dateBirth,
        passportSeries: this.$route.query.passportSeries,
        passportNumber: this.$route.query.passportNumber,
        currentMonitoringEnd: this.$route.query.currentMonitoringEnd,
        monitoringId: this.$route.query.monitoringId
      };
    },
  },
};
</script>


// WEBPACK FOOTER //
// RenewalMonitoringContainer.vue?7bc47255